export const routes = [
  { label: 'Find service', route: '/select-service', title: "Select a Service" },
  { label: 'Choose location', route: '/select-location', title: "Find a Location" },
  { label: 'Select insurance', route: '/select-insurance', title: "Select Insurance" },
  { label: 'Get estimate', route: '/price-guide', title: "Estimate Details" },
];

export default routes;